export default "__VITE_ASSET__C5sv965I__"